import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=79aeb02b&scoped=true&lang=css"

import exportComponent from "E:\\xampp7\\htdocs\\rnd_2023_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79aeb02b"]])

export default __exports__